import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Paquete de Actividades Pro',
  value: '15',
  desc: 'Más de 100 actividades listas para el aula — crucigramas químicos, sopas de letras temáticas, mapas conceptuales para completar, actividades de análisis de errores y problemas de aplicación con contexto latinoamericano, organizadas por tomo y nivel de dificultad.',
  benefit: 'Nunca más armés una actividad desde cero para llenar una clase.'
}, {
  id: '02',
  title: 'Banco de Evaluaciones y Rúbricas de Química',
  value: '12',
  desc: '30 modelos de evaluación completos organizados por tomo, nivel y tipo — múltiple choice con cuatro opciones, verdadero/falso con justificación y desarrollo graduado. Cada examen incluye su grilla de respuestas con fundamentos.',
  benefit: 'Nunca más construyas un examen desde cero bajo presión en el último momento.'
}, {
  id: '03',
  title: 'Manual de Bromatología y Análisis de Alimentos',
  value: '10',
  desc: 'El manual que no existe en ningún otro recurso didáctico de habla hispana. Composición química de los alimentos, métodos de análisis (Kjeldahl, Soxhlet, Fehling, Biuret), fraudes alimentarios frecuentes en LATAM y control de calidad en las industrias láctea, aceitera, azucarera y cafetalera de la región.',
  benefit: 'Ideal para escuelas técnicas agropecuarias y alimentarias — y para cualquier docente que quiera conectar la química con lo que sus alumnos comen todos los días.'
}, {
  id: '04',
  title: 'Guía de Gestión y Seguridad en Laboratorios Escolares',
  value: '8',
  desc: 'Protocolos de seguridad, manejo de reactivos, sistema SGA/GHS de etiquetado de peligros, gestión de residuos y primeros auxilios ante intoxicaciones químicas frecuentes en el contexto escolar latinoamericano. Todo explicado en lenguaje accesible para el docente y adaptable al nivel de los alumnos.',
  benefit: 'Nunca más entres a un laboratorio — aunque sea de guerrilla — sin saber exactamente qué hacer si algo sale mal.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-night border-y border-night-border" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-night-card border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-white" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-gray-400 text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-petrol-dark/20 via-gold/10 to-petrol-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-gray-300 mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34">USD 45,00</p>
          <p className="text-lg text-white mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-gold-light" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}